'use strict';
module.exports = require('./Timeline.vue');